import {
  getManageNoticeData,
  editManageNoticeReadData
} from '../libs/apis/ManageNoticeApi';

export const GET_MANAGE_NOTICE_REQUEST = 'GET_MANAGE_NOTICE_REQUEST';
export const GET_MANAGE_NOTICE_SUCCESS = 'GET_MANAGE_NOTICE_SUCCESS';
export const GET_MANAGE_NOTICE_FAILURE = 'GET_MANAGE_NOTICE_FAILURE';

export const EDIT_MANAGE_NOTICE_READ_REQUEST =
  'EDIT_MANAGE_NOTICE_READ_REQUEST';
export const EDIT_MANAGE_NOTICE_READ_SUCCESS =
  'EDIT_MANAGE_NOTICE_READ_SUCCESS';
export const EDIT_MANAGE_NOTICE_READ_FAILURE =
  'EDIT_MANAGE_NOTICE_READ_FAILURE';

export const getManageNotices = params => dispatch => {
  dispatch({ type: GET_MANAGE_NOTICE_REQUEST });
  return getManageNoticeData(params)
    .then(response =>
      dispatch({
        type: GET_MANAGE_NOTICE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MANAGE_NOTICE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editManageNoticeRead = (manageAccountId, params) => dispatch => {
  dispatch({ type: EDIT_MANAGE_NOTICE_READ_REQUEST });
  return editManageNoticeReadData(manageAccountId, params)
    .then(response =>
      dispatch({
        type: EDIT_MANAGE_NOTICE_READ_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_MANAGE_NOTICE_READ_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
